import React, {Component} from 'react';
import PrivateRoute from './components/PrivateRoute'
import {Route,Switch} from 'react-router-dom'
import Login from './routes/Login/index'
// import Login from './routes/Login2/index'
import Index from './routes/Index/index'
import './App.css'
import './assets/font/iconfont.css'
// import Ueditor from './components/ueditor/ueditor';

class App extends Component {
    componentDidMount(){
        // let UE = window.UE;
        // UE.getEditor('container', {
        //     autoHeightEnabled: true,
        //     autoFloatEnabled: true
        // });
    }
  render() {
    return (
      <Switch>
        <Route path='/login' component={Login}/>
        {/*<PrivateRoute path='/' component={Index}/>*/}
          <PrivateRoute path='/' component={Index}/>
          <textarea id="container"></textarea>
      </Switch>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js